import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const ActionTransfer = createSvgIcon(
  <svg
    width="254"
    height="249"
    viewBox="0 0 254 249"
    fill="none"
    fillRule="evenodd"
    clipRule="evenodd"
  >
    <g fill="currentColor">
      <path d="M243.087 10.7471H10.0762V238.907H243.087V10.7471ZM10.0762 0.827148C4.59758 0.827148 0.15625 5.26849 0.15625 10.7471V238.907C0.15625 244.386 4.59759 248.827 10.0763 248.827H243.087C248.565 248.827 253.007 244.386 253.007 238.907V10.7471C253.007 5.26848 248.565 0.827148 243.087 0.827148H10.0762Z" />
      <path d="M167.336 93.1804L148.172 74.3838L155.254 67.4375L181.5 93.1804L155.51 118.672L148.428 111.726L167.336 93.1804Z" />
      <path d="M72.8512 98.1453H172.742V88.2253H72.8512V98.1453Z" />
      <path d="M87.0138 160.173L106.178 178.97L99.096 185.916L72.8496 160.173L98.8399 134.681L105.922 141.628L87.0138 160.173Z" />
      <path d="M181.498 155.208L81.6074 155.208L81.6074 165.128L181.498 165.128L181.498 155.208Z" />
    </g>
  </svg>,
  'ActionTransfer'
);
